import { useState } from 'react';
import useToast from 'components/hooks/useToast';
import * as TrackingService from 'common/services/tracking.service';
import { TRACKING } from 'common/constants/constants';
import { isEqual, size } from 'lodash';

const useFormSaveHandler = ({ investmentCarvingSetting, formState }) => {
  const toast = useToast();
  const [isLoading, setIsLoading] = useState(false);

  const hasFormChanged = !isEqual(
    investmentCarvingSetting.value,
    formState.getSettingPayload()
  );
  const categoriesFiltersAreEmpty = formState.categories?.every(
    category => size(category.filters) === 0
  );

  const isSaveDisabled =
    isLoading || !hasFormChanged || categoriesFiltersAreEmpty;

  const onSaveSuccess = () =>
    toast({
      variant: 'success',
      message: `Report settings saved successfully`
    });

  const onSaveFailure = () =>
    toast({
      variant: 'error',
      message: `Ooops. Report settings could not be saved. please try again`
    });

  const onSaveConfiguration = async () => {
    try {
      setIsLoading(true);
      TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
        page: TRACKING.PAGES.INVESTMENT_PROFILE,
        click_type: TRACKING.CLICK.INVESTMENT_PROFILE.CONFIG.SAVE
      });
      const settingPayload = formState.getSettingPayload();
      await investmentCarvingSetting.onSave(settingPayload);
      onSaveSuccess();
    } catch (e) {
      onSaveFailure();
    } finally {
      setIsLoading(false);
    }
  };

  const onRevertToDefaults = async () => {
    try {
      setIsLoading(true);
      await investmentCarvingSetting.onDelete();
      onSaveSuccess();
    } catch (e) {
      onSaveFailure();
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    onSaveConfiguration,
    onRevertToDefaults,
    isSaveDisabled
  };
};

export default useFormSaveHandler;
